import styled from 'styled-components';

export {
  Hint,
  Optional,
} from '@rewardopl/react-ui/field/index.styles';

export const Wrapper = styled.fieldset`
  margin: 0;
  padding: 0;
  border: 0;
`;

export const Label = styled.legend`
  width: 100%;
  padding: 0;
  margin-bottom: 8px;
  font-weight: 600;
  text-align: left;
`;
